import { useEffect, useState } from "react";
import "./AudioSpectrum.scss";

const BAR_COUNT = 24;
const emptySpectrum = () => Array.from({ length: BAR_COUNT }, () => 0.08);

export function AudioSpectrum({ nodeID }: { nodeID: string }) {
  const [levels, setLevels] = useState(emptySpectrum);

  useEffect(() => {
    let active = true;
    let timeout: number | undefined;

    const poll = async () => {
      try {
        const response = await fetch(
          `/api/workflow/runtime/outputs/${nodeID}/audio-spectrum`,
        );
        if (response.ok && active) {
          const data = (await response.json()) as { levels?: number[] };
          if (data.levels?.length) setLevels(data.levels.slice(0, BAR_COUNT));
        }
      } catch {
        // Keep last spectrum while runtime or audio source reconnects.
      }
      if (active) timeout = window.setTimeout(poll, 250);
    };

    void poll();
    return () => {
      active = false;
      if (timeout) window.clearTimeout(timeout);
    };
  }, [nodeID]);

  return (
    <div className="audio-spectrum" role="img" aria-label="Audio spectrum">
      {levels.map((level, index) => (
        <span
          className="audio-spectrum-bar"
          key={index}
          style={{ height: `${Math.max(8, Math.min(100, level * 100))}%` }}
        />
      ))}
    </div>
  );
}
